class CustomerInformations {
  constructor(id, name, typo_category, typo_type, phone) {
    this._id = id;
    this._name = name;
    this._typo_category = typo_category;
    this._typo_type = typo_type;
    this._phone = phone;
  }

  // Getter
  getId() {
    return this._id;
  }

  getName() {
    return this._name;
  }

  getTypoCategory() {
    return this._typo_category;
  }

  getTypoType() {
    return this._typo_type;
  }

  getPhone() {
    return this._phone;
  }

  // setter
  setId(newId) {
    this._id = newId;
    return this;
  }

  setName(newName) {
    this._name = newName;
    return this;
  }

  setPhone(newPhone) {
    this._phone = newPhone;
    return this;
  }

  setTypoCategory(newTypoCategory) {
    this._typo_category = newTypoCategory;
    return this;
  }

  setTypoType(newTypoType) {
    this._typo_type = newTypoType;
    return this;
  }

  serialize() {
    return { ...this, '@type': 'CustomerInformations' };
  }

  // clone Object
  clone() {
    return new CustomerInformations(
      this._id,
      this._name,
      this._typo_category,
      this._typo_type,
      this._phone,
    );
  }

  static deserialize(raw) {
    return new CustomerInformations(
      raw._id,
      raw._name,
      raw._typo_category,
      raw._typo_type,
      raw._phone,
    );
  }
}

export default CustomerInformations;



// WEBPACK FOOTER //
// ./src/models/CustomerInformations.js